var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg14098171681556105309(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 48c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4 36.266a2.14 2.14 0 01-2.134 2.134H23.998c-8.926 0-15.95-8.128-14.1-17.377 1.137-5.692 5.671-10.12 11.38-11.17a14.395 14.395 0 0117.104 13.429h.018v12.984z",
    fill: "#F4B70A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.662 31.131s.538.32.538-.42v-6.835A7.199 7.199 0 0024 16.8a7.198 7.198 0 00-7.2 7.195 7.198 7.198 0 007.2 7.196 7.175 7.175 0 004.761-1.798l1.901 1.738z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg14098171681556105309);
export default __webpack_public_path__ + "static/media/14098171681556105309.4bdc0c79a47c24ccc3b6aae5316cfa3f.svg";
export { ForwardRef as ReactComponent };